"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryThreeDS = void 0;

var _common = require("./../common");

var _service = require("./../service");

class BasisTheoryThreeDS extends _service.BasisTheoryService {
  getSessionById(sessionId) {
    return this.client.get(`/${sessionId}`).then(_common.dataExtractor);
  }

  authenticateSession(sessionId, authenticateRequest) {
    return this.client.post(`/${sessionId}/authenticate`, authenticateRequest).then(_common.dataExtractor);
  }

  getChallengeResult(sessionId) {
    return this.client.get(`/${sessionId}/challenge-result`).then(_common.dataExtractor);
  }

}

exports.BasisTheoryThreeDS = BasisTheoryThreeDS;